import PageLayout from "components/shared/pageLayout/PageLayout";
import About from "components/about/About";

function OverOns() {
    return (
        <PageLayout
            slug="over-ons"
            title="Over ons | Lees! Cadeau"
            description="Bekijk hier de over ons pagina van Lees! Cadeaukaart. "
        >
            <About />
        </PageLayout>
    );
}

export default OverOns;
